import { render, staticRenderFns } from "./swWeakSignals.vue?vue&type=template&id=9e88d662&scoped=true"
import script from "./swWeakSignals.vue?vue&type=script&lang=js"
export * from "./swWeakSignals.vue?vue&type=script&lang=js"
import style0 from "./swWeakSignals.vue?vue&type=style&index=0&id=9e88d662&prod&lang=scss"
import style1 from "./swWeakSignals.vue?vue&type=style&index=1&id=9e88d662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e88d662",
  null
  
)

export default component.exports